import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function LoginScreen() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const { login, error, loading, clearError } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!phone.trim() || !password.trim()) return;
    const success = await login(phone.trim(), password, rememberMe);
    if (success) {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-container">
        <div className="auth-icon">🐝</div>
        <h1 className="auth-title">BEETWEET</h1>
        <p className="auth-sub">Playful messaging with calls 🎉</p>
        <form onSubmit={handleLogin} className="auth-form">
          <input
            className="auth-input"
            type="tel"
            placeholder="+ Phone number"
            value={phone}
            onChange={(e) => { setPhone(e.target.value); clearError(); }}
          />
          <div className="password-field">
            <input
              className="auth-input"
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); clearError(); }}
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? '🙈' : '👁️'}
            </button>
          </div>
          <label className="remember-me">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <span>Remember me</span>
          </label>
          {error && <div className="auth-error">{error}</div>}
          <button className="auth-button" type="submit" disabled={loading}>
            {loading ? <span className="spinner" /> : 'Login'}
          </button>
        </form>
        <div className="auth-footer">
          Don't have an account? <Link to="/register">Register</Link>
        </div>
      </div>
    </div>
  );
}
